// extracted by mini-css-extract-plugin
export default {"mainSection":"styles_mainSection__2qalR","coursesDashboard":"styles_coursesDashboard__+I9Gg"};